import { render, staticRenderFns } from "./WhatsappProfileSettings.vue?vue&type=template&id=7aac8e44&"
import script from "./WhatsappProfileSettings.vue?vue&type=script&lang=js&"
export * from "./WhatsappProfileSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports